import { BrandInfo } from "src/molecules/BrandInfo";
import { Modal } from "src/atoms/Modal";
import type { AlgoliaSearchBrand } from "src/types/Algolia.d";

interface BrandInfoModal {
  brand: AlgoliaSearchBrand;
  open: boolean;
  loading?: boolean;
  onClose: () => void;
}

const NewBrandInfoModal = ({
  open,
  brand,
  loading,
  onClose,
}: BrandInfoModal): JSX.Element => {
  return (
    <Modal isOpen={open} onClose={onClose} overFlow="hidden">
      <BrandInfo brandInfo={brand} onClose={onClose} pageType="brandsPage" />
    </Modal>
  );
};

export { NewBrandInfoModal };
